import { IUpdateCentroCustoSecundarioUseCase } from "../../../presentation/useCases/update/update_centro_custo_secundario_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateCentroCustoSecundarioUseCase
 */


export class UpdateCentroCustoSecundarioUseCase implements IUpdateCentroCustoSecundarioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateCentroCustoSecundario(
    idFuncionarioCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.repository.updateCentroCustoSecundario(
      idFuncionarioCentroCusto,
      idCentroCusto,
    );
  }
}